import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { IdpModel } from '../../../models';
import { AuthStore } from '../../../state/auth.store';
import { SsoOauthService } from './oauth';
import { SsoOktaService } from './okta';
import { SsoSamlService } from './saml/sso-saml.service';
import { SsoIdpBaseService } from './sso-idp-base.service';
import { SsoIdpHttpService } from './sso-idp-http.service';
import { isOauthIdp, isOktaIdp, isSamlIdp } from './sso-idp.util';

@Injectable()
export class SsoIdpsResolverService {
  constructor(
    private readonly ssoIdpHttpService: SsoIdpHttpService,
    private readonly ssoSamlService: SsoSamlService,
    private readonly ssoOktaService: SsoOktaService,
    private readonly ssoOauthService: SsoOauthService,
    private readonly authStore: AuthStore,
  ) {}

  fetchAll(): Observable<void> {
    return this.ssoIdpHttpService.getAll().pipe(
      tap((idps) => {
        this.authStore.setSsoIdps(idps);
      }),
      map(() => undefined),
    );
  }

  getIdpService(idp: IdpModel): SsoIdpBaseService | null {
    if (isSamlIdp(idp)) {
      return this.ssoSamlService;
    }
    if (isOktaIdp(idp)) {
      return this.ssoOktaService;
    }
    if (isOauthIdp(idp)) {
      return this.ssoOauthService;
    }
    return null;
  }
}
